import React from 'react'
import './App.css';
import ScrollTop from './general/ScrollTop';
import Header from './general/header/Header'
import { Route, Routes } from 'react-router-dom'
import Home from './components/home/Home'
import About from './components/about/About'
import Contact from './components/contact/Contact'
import Career from './components/careers/Career'
import Blog from './components/blog/Blog'
import Calculator from './components/calculator/Calculator';
import Mutual from './components/services/mutualfunds/Mutual';
import PMS from './components/services/pms/PMS';
import AIF from './components/services/aif/AIF';
import MT from './components/services/macroTreasury/MT';
import NRI from './components/services/nri/NRI';
import Family from './components/services/familyoffices/Family';
import Insurance from './components/services/insurance/Insurance';
import Loan from './components/services/loansyndication/Loan';
import SME from './components/services/smeipoadvisory/SME';
import Fundraising from './components/services/fundraisingassistance/Fundraising';
import Privacy from './general/privacypolicy/Privacy';
import Desclaimer from './general/disclaimer/Disclaimer';
import AdminLogin from './components/admin/AdminLogin';
import AdminDashboard from './components/admin/AdminDashboard';
import Stock from './components/services/stockbroking/Stock';
import AdminEnquiry from './components/admin/AdminEnquiry';
import Register from './components/Regsiter';
import Login from './components/Login';
import NseRegistration from './components/NseRegistration';


const App = () => {
  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";


  return (
    <>
      <ScrollTop />


      {!isLoggedIn && (
        <>
          <Header />
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/about' element={<About />} />
            <Route path='/contact' element={<Contact />} />
            <Route path='/careers' element={<Career />} />
            <Route path='/blog' element={<Blog />} />
            <Route path='/calculators' element={<Calculator />} />
            <Route path='/mutual-funds' element={<Mutual />} />
            <Route path='/portfolio-management-services' element={<PMS />} />
            <Route path='/alternative-investment-funds' element={<AIF />} />
            <Route path='/macro-treasury-research' element={<MT />} />
            <Route path='/nri-corner' element={<NRI />} />
            <Route path='/family-offices' element={<Family />} />
            <Route path='/insurance' element={<Insurance />} />
            <Route path='/loan-syndication' element={<Loan />} />
            <Route path='/sme-ipo-advisory' element={<SME />} />
            <Route path='/fundraising-assistance' element={<Fundraising />} />
            <Route path='/privacy-policy' element={<Privacy />} />
            <Route path='/disclaimer' element={<Desclaimer />} />
            <Route path='/admin-login' element={<AdminLogin />} />
            <Route path='/stock-broking' element={<Stock />} />
            <Route path='/nse-registration' element={<Register />}/>
            <Route path='/nse-login' element={<Login />} />
            <Route path='/nse-kyc-register' element={<NseRegistration />} />
          </Routes>
        </>
      )}


      {isLoggedIn && (
        <>
          <Routes>
            <Route exact path='/' element={<AdminDashboard />} />
            <Route exact path='/dashboard' element={<AdminDashboard />} />
            <Route exact path='/enquiry' element={<AdminEnquiry />} />
          </Routes>
        </>
      )}

    </>
  )
}

export default App